class RelatedProducts extends HTMLElement {
  constructor() {
    super();
    this.onIntersect = this.onIntersect.bind(this);
  }

  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    this.observer = new IntersectionObserver(this.onIntersect, { rootMargin: '0px 0px 200px 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  onIntersect(entries) {
    if (!entries[0].isIntersecting) return;
    this.observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const content = html.querySelector('[data-related-products-content]');
        if (!content) return;

        if (content.innerHTML.trim().length) {
          this.innerHTML = content.innerHTML;
        }
      })
      .catch((e) => console.error(e));
  }
}

customElements.define('related-products', RelatedProducts);
